import React from "react";
import EvidenceToolTip from "../../EvidenceToolTip";

export default function EvidenceLevelBadgeProcessor(options) {
  const evidenceLevelBadge = (node) => {
    const loeLevel = node?.attribs["data-evidence-level"];
    const badgeText = "DynaMed Level";
    return (
      <EvidenceToolTip
        loeLevel={loeLevel}
        badgeText={badgeText}
        setIsEvidenceBottomSheetOpen={options.setIsEvidenceBottomSheetOpen}
        loe={options.loe}
      />
    );
  };

  return { evidenceLevelBadge };
}
